import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
}

const Divider: FC<Props> = ({ className }) => {
  return (
    <div className={twMerge('py-1 h-full', className)}>
      <div className='h-full  w-[1.5px] min-w-[1.5px] bg-grayZl-900  ' />
    </div>
  );
};

export default Divider;
